import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-9 h-9", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill={light ? "#FAF8F5" : "#1B3B2B"} />
    <path d="M14 46V20l18 18 18-18v26" fill="none" stroke={light ? "#1B3B2B" : "#FAF8F5"} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="32" cy="15" r="4" fill="#C59B27" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <Link to="/" className="group flex items-center gap-3" aria-label="Motive Press home" data-testid="header-logo-link">
    <span className="transition-transform duration-500 group-hover:rotate-[-8deg]">
      <LogoMark light={light} />
    </span>
    <span className={`font-display text-[1.6rem] leading-none ${light ? "text-[var(--paper)]" : "text-[var(--ink)]"}`}>
      Motive <em className="italic">Press</em>
    </span>
  </Link>
);
